module.exports = __webpack_public_path__ + "img/foundation.fefe046c.jpg";